import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget-main-layout',
  templateUrl: './widget-main-layout.component.html',
  styleUrls: ['./widget-main-layout.component.scss'],
})
export class WidgetMainLayoutComponent implements OnInit {
  @Input() showAccountSummaryWidget = false;
  @Input() showQuickLinks = false;
  @Input() accountSummaryWidgetFixedToScrolling = false;

  showViewWishlist = false;
  showViewCart = false;
  quickLinkRoute: string;
  quickLinkName: string;

  constructor(private location: Location) {}

  ngOnInit(): void {
    // TODO analyze which paths should really show the buttons
    if (this.location.path().includes('product-catalogue')) {
      this.showViewWishlist = true;
      this.showViewCart = true;
    } else {
      this.showViewWishlist = false;
      this.showViewCart = false;
    }

    if (this.location.path().includes('faq')) {
      this.quickLinkRoute = '/program-overview';
      this.quickLinkName = 'PROGRAM OVERVIEW';
    } else {
      this.quickLinkRoute = '/support/faq';
      this.quickLinkName = 'FAQ';
    }
  }
}
